module.exports = __webpack_public_path__ + "img/logo1.ff405c7d.png";